"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VALIDATION_MODE = void 0;
exports.VALIDATION_MODE = {
    onBlur: 'onBlur',
    onChange: 'onChange',
    onSubmit: 'onSubmit',
    all: 'all',
    default: 'default',
};
//# sourceMappingURL=constants.js.map